/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Missing_Items_Ship_LaterInputs */

const en_missing_items_ship_later = /** @type {(inputs: Missing_Items_Ship_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A later shipment`)
};

/**
* | output |
* | --- |
* | "A later shipment" |
*
* @param {Missing_Items_Ship_LaterInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const missing_items_ship_later = /** @type {((inputs?: Missing_Items_Ship_LaterInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Missing_Items_Ship_LaterInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_missing_items_ship_later(inputs)
});